import ENV from '../base/env';
import { EDomain } from '../base/types';

export const AssetsBaseUrl = ENV.AssetsBaseUrl;
/**
 * function return the path to the exercise icon according to given id and additional flags
 * @param exerciseId exercise name (aka id)
 * @param completed boolean flag to show checkmark instead of icon
 * @param locked boolean flag to show lock icon instead of icon
 */
export function getExerciseIconSrc(exerciseId: string, completed = false, locked = false) {
  let iconName: string;

  if (completed) {
    iconName = 'icon-checked.png';
  } else if (locked) {
    iconName = 'icon-blocked.png';
  } else {
    iconName = `${exerciseId}.svg`;
  }

  return `${AssetsBaseUrl}/feature/exercise-icons/${iconName}`;
}

export const AddFriendsIcon = `${AssetsBaseUrl}/feature/add-friends.png`;

export function getDomainIconSrc(domain: EDomain) {
  return `${AssetsBaseUrl}/feature/icons/${EDomain[domain]}.png`;
}

export function getCompletedIconSrc() {
  return `${AssetsBaseUrl}/feature/exercise-icons/icon-checked.png`;
}
